import { getContent, injectCSS } from "../utils/retorikUtils";

const botEventHandler: any = (action: any, _dispatch?: any): boolean => {
  console.log("Action : ", action);
  if (!action) {
    return false;
  }
  if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
    // Bot Started
    // Inject CSS to Shadow
    injectCSS();
  }

  //console.log("Action type : ", action.type);
  //console.log("Action name : ", action?.payload?.activity?.value?.name);
  if (
    action.type === "DIRECT_LINE/POST_ACTIVITY_FULFILLED" &&
    (action.payload?.activity?.value?.name ===
      "hospitality.showContentItemById" ||
      action.payload?.activity?.value?.name === "hospitality.showPoiById")
  ) {
    let identifier = action.payload?.activity?.value?.identifier;
    if (!identifier) {
      identifier = action.payload?.activity?.value?.Identifier;
    }
    if (identifier) {
      console.log("Get content with ID : ", identifier);
      localStorage.removeItem("currentContentItem");
      getContent(identifier)
        .then((content) => {
          if (content) {
            console.log("Contenu récupéré:", content);
            localStorage.setItem("currentContentItem", JSON.stringify(content));
          } else {
            console.log(
              "Le contenu n'a pas pu être récupéré ou n'est pas valide.",
            );
          }
        })
        .catch((error) => {
          console.error("Erreur:", error);
        });
    }
  }

  return false;
};

export { botEventHandler };
